/* No tracking, cart manipulation or customer-data handling. EasySell owns checkout. */
(() => {
  if (window.__sxProductLoaded) return;
  window.__sxProductLoaded = true;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-sx-product]').forEach(root => {
      if (root.dataset.sxReady) return;
      root.dataset.sxReady = 'true';
      const buttons = [...root.querySelectorAll('[data-sx-target]')];
      buttons.forEach(button => button.addEventListener('click', () => {
        const target = root.querySelector(`[id="${CSS.escape(button.dataset.sxTarget)}"]`);
        if (!target) return;
        root.querySelectorAll('[data-sx-media]').forEach(media => {
          media.hidden = media !== target;
          if (media.hidden) {
            media.querySelectorAll('video').forEach(video => video.pause());
            media.querySelectorAll('iframe').forEach(frame => {
              if (frame.src.includes('youtube.com')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), 'https://www.youtube.com');
              if (frame.src.includes('vimeo.com')) frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), 'https://player.vimeo.com');
            });
          }
        });
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      // A full navigation lets both Shopify and EasySell read the same selected variant.
      root.querySelectorAll('[data-sx-variant-select]').forEach(select => {
        select.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', select.value);
          window.location.assign(url.href);
        });
      });
      const orderArea = root.querySelector('[data-sx-order-area]');
      const sticky = root.querySelector('[data-sx-sticky]');
      // Keep the Shopify button as fallback until EasySell really inserts its own button.
      // The native product form stays in the DOM so EasySell can read the variant.
      if (orderArea && orderArea.querySelector('#es-form-hook')) {
        const syncEasySell = () => {
          const button = orderArea.querySelector('.es-popup-button-product');
          const ready = Boolean(button && getComputedStyle(button).display !== 'none');
          if (root.classList.contains('sx-easysell-ready') !== ready) root.classList.toggle('sx-easysell-ready', ready);
        };
        syncEasySell();
        const appObserver = new MutationObserver(syncEasySell);
        appObserver.observe(orderArea, {childList: true, subtree: true});
        root._sxAppObserver = appObserver;
      }
      if (orderArea && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting;
        }, {threshold:0.05});
        observer.observe(orderArea);
        root._sxObserver = observer;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-sx-product]').forEach(root => {root._sxObserver?.disconnect(); root._sxAppObserver?.disconnect();}));
})();
